import { useEffect } from 'react';
import { getInlineHelpStoreValue } from '../store/inlineHelpStore';
import useStoreLoader from './useStoreLoader';
import { inlineHelpContentAction$, inlineHelpContentStore$ } from '../store/inlineHelpContentStore';

function useInlineHelpContentActions() {

  const { pageId } = getInlineHelpStoreValue();
  const { isLoading } = useStoreLoader(inlineHelpContentAction$, inlineHelpContentStore$ );

  useEffect(() => {
    inlineHelpContentAction$.next({
      pageId
    });
  }, [pageId]);

  return {
    isLoading
  };
}

export default useInlineHelpContentActions;